/**
 * Checks if a person is under 21 years old based on their date of birth.
 *
 * @param dob - The date of birth in ISO format (YYYY-MM-DD) or a Date object.
 * @returns true if under 21, false if 21 or older.
 */
export function isUnder21(dob: string | Date): boolean {
    if (!dob) return true;

    const birthDate = typeof dob === "string" ? new Date(dob) : dob;
    if (isNaN(birthDate.getTime())) {
        console.warn("Invalid DOB provided to isUnder21:", dob);
        return true; // assume underage if DOB is invalid
    }

    const today = new Date();

    const age21Date = new Date(
        birthDate.getFullYear() + 21,
        birthDate.getMonth(),
        birthDate.getDate()
    );

    return today < age21Date;
}
